import { getSubdomain } from 'utils/domain'

/**
 * Host with tenant subdomain stripped (same idea as `authStore.logout`).
 * e.g. `altec.localhost:3000` → `localhost:3000`
 */
function getMainHost(): string {
  const subdomain = getSubdomain()
  return window.location.host.replace(/^(www\.)/, '').replace(new RegExp(`^(${subdomain}\\.)`), '')
}

/**
 * Origin used to open the Google bind completion page (`/link-google`).
 *
 * - **`REACT_APP_GOOGLE_BIND_USE_MAIN_HOST_ORIGIN=true`**: `{protocol}//{mainhost}` (no `app.` subdomain).
 * - **Otherwise**: `{protocol}//app.{mainhost}`.
 */
export function getAppOriginUrl(): string {
  const protocol = window.location.protocol
  const mainhost = getMainHost()

  if (import.meta.env.REACT_APP_GOOGLE_BIND_USE_MAIN_HOST_ORIGIN === 'true') {
    return `${protocol}//${mainhost}`
  }
  return `${protocol}//app.${mainhost}`
}
